<template>
   <div class="app-card" :class="customClasses" ref="card">
      <v-card-text :class="customCardClasses">
         <div class="layout justify-space-between pa-3">
            <div class="align-item-start">
               <h3 class="fw-bold mb-1">
                  {{heading}}
               </h3>
               <p class="ma-0 fs-12 grey--text" v-if="description">{{description}}</p>
            </div>
            <div class="align-item-end">
               <h3 class="dash-icon"><i :class="icon"></i></h3>
            </div>
         </div>
         <slot></slot>
      </v-card-text>
      
   </div>
</template>
<script>

    export default {
        props: ["heading", "colClasses", "customClasses", 'customCardClasses', "icon", 'description'],
        methods: {
            resize() {
                console.log('ssss')
            }
        },
        mounted () {
            this.$refs.card.addEventListener('onresize', this.resize)
        }
    }
</script>
